import React, { useState } from "react";

const Header = () => {
  // State to manage mobile menu visibility
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="bg-white shadow-md">
      {/* Header Section with Navigation */}
      <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4 flex justify-between items-center">
        {/* Logo/Title - responsive text size */}
        <h1 className="text-xl sm:text-2xl font-bold text-gray-800 truncate pr-2">OPENAPIPASS DEVELOPERS</h1>
        
        {/* Navigation Links - hidden on mobile */}
        <div className="hidden md:flex items-center space-x-6">
          <a href="/polyfintech" className="text-gray-700 hover:text-blue-600 font-medium">PolyFinTech</a>
          <a href="/get-started" className="text-gray-700 hover:text-blue-600 font-medium">Get Started</a>
          <a href="/privacy-policy" className="text-gray-700 hover:text-blue-600 font-medium">Privacy Policy</a>
          <a
            href="/"
            className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md text-center font-medium"
          >
            Sign In
          </a>
        </div>
        
        {/* Mobile Menu Button - Shows only on small screens */}
        <div className="md:hidden flex items-center">
          <button 
            onClick={toggleMobileMenu}
            className="text-gray-500 hover:text-gray-800 p-2 focus:outline-none"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
      
      {/* Mobile Navigation - Conditionally displayed based on state */}
      <div className={`md:hidden ${isMobileMenuOpen ? 'block' : 'hidden'} transition-all duration-300`}>
        <div className="px-2 pt-2 pb-3 space-y-1 shadow-inner bg-gray-50">
        <a href="/polyfintech" className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-600 rounded-md">
            PolyFinTech
          </a>
          <a href="/get-started" className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-600 rounded-md">
            Get Started
          </a>
          <a href="/privacy-policy" className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-600 rounded-md">
            Privacy Policy
          </a>
              <a href="/" className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-600 rounded-md">
            Sign In
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;  